// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--1Ukgr","active":"index-module--active--natU8"};